export default "__VITE_ASSET__CLBladL9__"